import { useEffect, useState } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import { motion, AnimatePresence } from "framer-motion";
import { Menu, X } from "lucide-react";
import Socials from "./Socials";
import { NAV_ITEMS } from "@/data/content";
import { EASE } from "./MaskedLines";

export default function MobileNav() {
    const [open, setOpen] = useState(false);
    const { pathname } = useLocation();

    useEffect(() => {
        setOpen(false);
    }, [pathname]);

    useEffect(() => {
        document.body.style.overflow = open ? "hidden" : "";
        return () => {
            document.body.style.overflow = "";
        };
    }, [open]);

    return (
        <>
            <header className="lg:hidden fixed inset-x-0 top-0 z-50 flex h-16 items-center justify-between bg-ink px-5 text-paper">
                <Link
                    to="/"
                    data-testid="mobile-wordmark"
                    className="mono font-bold"
                >
                    _beingdevang<span className="blink text-sage">_</span>
                </Link>
                <button
                    onClick={() => setOpen((o) => !o)}
                    data-testid="mobile-menu-button"
                    aria-label="Toggle menu"
                    className="grid h-10 w-10 place-items-center rounded-full border border-paper2/30 transition-colors hover:border-sage hover:text-sage"
                >
                    {open ? (
                        <X className="h-5 w-5" />
                    ) : (
                        <Menu className="h-5 w-5" />
                    )}
                </button>
            </header>

            <AnimatePresence>
                {open && (
                    <motion.div
                        initial={{ opacity: 0 }}
                        animate={{ opacity: 1 }}
                        exit={{ opacity: 0 }}
                        transition={{ duration: 0.3 }}
                        className="fixed inset-0 z-40 flex flex-col justify-center bg-ink px-8 pb-10 pt-16 lg:hidden"
                        data-testid="mobile-menu"
                    >
                        <nav className="flex flex-col gap-3">
                            {NAV_ITEMS.map((item, i) => (
                                <motion.div
                                    key={item.path}
                                    initial={{ y: 28, opacity: 0 }}
                                    animate={{ y: 0, opacity: 1 }}
                                    transition={{
                                        delay: 0.08 + i * 0.05,
                                        duration: 0.5,
                                        ease: EASE,
                                    }}
                                >
                                    <NavLink
                                        to={item.path}
                                        end={item.path === "/"}
                                        data-testid={`nav-link-${item.id}`}
                                        className={({ isActive }) =>
                                            `font-display text-4xl leading-tight ${
                                                isActive
                                                    ? "text-sage"
                                                    : "text-paper"
                                            }`
                                        }
                                    >
                                        <span className="mono text-sm align-super mr-3 text-sage">
                                            0{i + 1}
                                        </span>
                                        {item.label}
                                    </NavLink>
                                </motion.div>
                            ))}
                        </nav>
                        <motion.div
                            initial={{ opacity: 0 }}
                            animate={{ opacity: 1 }}
                            transition={{ delay: 0.5 }}
                            className="mt-12 text-paper"
                        >
                            <Socials />
                        </motion.div>
                    </motion.div>
                )}
            </AnimatePresence>
        </>
    );
}
